<div class="cintaSuperior">
    <div class="container spaceContainer">
        <div class="contenedorCintaSuperior">
            <a class="cursor-pointer" (click)="mostrarAlerta('Gov Co','https://www.gov.co/','_blank')" alt="Enlace a página del gobierno">
                <img tabindex="0" class="logoGovSuperior" alt="Logo Gov Co" matTooltip="Enlace a página del gobierno"
                src="../../../assets/img/cinta/logo-gov-cinta-superior-e-inferiorTransparente.png">    
            </a>
        </div>
    </div>
</div>
